export default __webpack_public_path__ + "static/media/eye-color.cff66c09.svg";